// extracted by mini-css-extract-plugin
module.exports = {"container":"Textarea_container__5jVaG","textarea":"Textarea_textarea__xo_aw"};